import { render, staticRenderFns } from "./dettaglioPalestra.vue?vue&type=template&id=05b64de2"
import script from "./dettaglioPalestra.vue?vue&type=script&lang=js"
export * from "./dettaglioPalestra.vue?vue&type=script&lang=js"
import style0 from "./dettaglioPalestra.vue?vue&type=style&index=0&id=05b64de2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports